function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M936,504c0-238-194-432-432-432S72,266,72,504s194,432,432,432S936,742,936,504z M1008,504 c0,278-226,504-504,504S0,782,0,504S226,0,504,0S1008,226,1008,504z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M498.3,255c-24,0-45,21-45,45s21,45,45,45c24,0,45-21,45-45S522.3,255,498.3,255z M498.3,192 c59,0,108,49,108,108s-49,108-108,108s-108-49-108-108S439.3,192,498.3,192z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M680,562.2c-24,0-45,21-45,45s21,45,45,45s45-21,45-45S704,562.2,680,562.2z M680,499.2c59,0,108,49,108,108 s-49,108-108,108s-108-49-108-108S621,499.2,680,499.2z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M327.8,561.6c-24,0-45,21-45,45s21,45,45,45s45-21,45-45S351.8,561.6,327.8,561.6z M327.8,498.6 c59,0,108,49,108,108s-49,108-108,108s-108-49-108-108S268.8,498.6,327.8,498.6z"
});

function SvgPigGroups(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1008 1008",
    fill: "currentColor",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPigGroups);
export default __webpack_public_path__ + "static/media/pig-groups.e9232fff.svg";
export { ForwardRef as ReactComponent };